import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/settings/workspace/personalization/")({
	beforeLoad: () => {
		throw redirect({ to: "/settings/workspace" });
	},
});
